import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export default function RequireAccessCode() {
    const access = localStorage.getItem('accessGranted');
    const location = useLocation();
    if (access === 'true') return <Outlet />;
    if (location.pathname === '/access-code') return <Outlet />;
    return <Navigate to="/access-code" state={{ from: location }} replace />;
}
